module.exports = __webpack_public_path__ + "static/matt-avatar-4d23375d95275cf96e162c7adc2fbbaf.png";